// extracted by mini-css-extract-plugin
module.exports = {"long":"StatsText_long__33LoG","first":"StatsText_first__wFU4E","end":"StatsText_end__PsSvj"};